module.exports = __webpack_public_path__ + "img/nutrition_3.9d2ccf2f.jpg";